module.exports = __webpack_public_path__ + "img/heating-lg.a735e41f.svg";